<template>
  <v-btn :elevation="elevation"
         :color="color"
         :block="!inline"
         :dark="dark"
         :light="!dark"
         :to="to"
         :href="href"
         :text="text || subButton || transparent"
         :large="!subButton"
         :tile="tile"
         :rounded="rounded"
         :disabled="disabled"
         :loading="loading"
         shaped
         :height="height"
         max-width="600"
         @click="click"
  >
    <div class="d-flex flex-column text-center " :class="classesMain">
      <div v-if="(title || $slots.default)" class="text-center text-no-wrap">
        {{ title ? $dictionary.get(title) : null }}
        <slot />
      </div>
      <div v-if="subtitle || $slots.subtitle"
           class="text-lowercase text-caption text-center text-no-wrap"
           :class="classesSubtitle"
           style="line-height: 0.7rem"
      >
        {{ subtitle ? $dictionary.get(subtitle) : '' }}
        <slot name="subtitle" />
      </div>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    title: { type: String, default: null },
    href: { type: String, default: null },
    subtitle: { type: String, default: null },
    inline: { type: Boolean, default: false },
    to: { type: [String, Object], default: null },
    transparent: { type: Boolean, default: false },
    subButton: { type: Boolean, default: false },
    grey: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    reversed: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    colorOverride: { type: String, default: null },
    darkOverride: { type: Boolean, default: null },
    height: { type: Number, default: null },
  },
  computed: {
    elevation() {
      if (this.subButton) return 0;
      return this.$store.state.theme.buttonElevation;
    },
    text() { return this.$store.state.theme.buttonType === 'text'; },
    tile() { return this.$store.state.theme.buttonType === 'tile'; },
    rounded() { return this.$store.state.theme.buttonType === 'rounded'; },
    dark() {
      if (this.darkOverride !== null) return this.darkOverride;
      if (this.subButton) return this.$store.state.theme.mainDark;
      return this.$store.state.theme.buttonDark;
    },
    color() {
      if (this.transparent) return null;
      if (this.colorOverride !== null) return this.colorOverride;
      if (this.subButton && !this.text) return null;
      if (this.grey) return 'grey';
      return this.$store.state.theme.buttonColor;
    },
    classesSubtitle() {
      return {
        'pt-1': this.reversed
      };
    },
    classesMain() {
      return {
        'flex-column-reverse': this.reversed
      };
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
